import { getContrast } from "polished";
import styled, { type StyledProps } from "styled-components";

export const StyledMobileQRCodeButton = styled.button`
  display: none;

  @media (max-width: 767px) {
    width: 64px;
    height: 100px;
    border-radius: 32px;
    box-shadow: 0 0 8px 0 #ccc;
    border: none;
    background: ${({ theme }: StyledProps<{}>) =>
      theme.auth_page.background_color};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    p {
      position: absolute;
      bottom: 0;
      font-family: ${({ theme }: StyledProps<{}>) =>
        theme.primary_font.bold.font_family};
      font-size: 16px;
      color: ${({ theme }: StyledProps<{}>) =>
        getContrast(
          theme.auth_page.background_color ?? "#fff", // if the background isn't set, we should know its white, (a valid color is important for the `getContrast` function to succeed)
          theme.global.primary_active_color
        ) > 4.5
          ? theme.global.primary_active_color
          : theme.auth_page.font.color};
    }
  }
`;

export const StyledQRCodeIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 24px;
  background: ${({ theme }) => theme.global.primary_active_color};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 7px;
`;

export const StyledQRCodeContainer = styled.div`
  position: fixed;
  bottom: var(--safe-offset--descending, 0);
  margin-bottom: var(--size-4);
  right: var(--size-4);
`;
